import { Loader2, Save } from "lucide-react";
import { inr } from "../../lib/format";
import { useClient } from "../../context/ClientContext";

export const TotalsBar = ({ totals, onSave, saving, uploading, label }) => {
  const { quick } = useClient();
  return (
  <div className={`fixed inset-x-0 ${quick ? "bottom-0 pb-[env(safe-area-inset-bottom)]" : "bottom-[calc(4rem+env(safe-area-inset-bottom))]"} z-30 border-t bg-card/95 shadow-[0_-8px_24px_-12px_rgba(0,0,0,.25)] backdrop-blur-lg`}
    data-testid="po-totals-bar">
    <div className="mx-auto flex max-w-3xl items-center gap-3 px-4 py-3">
      <div className="min-w-0 flex-1">
        <p className="mono truncate text-xs text-muted-foreground" data-testid="totals-taxable-gst">
          {inr(totals.taxable)} + GST {inr(totals.tax)}
        </p>
        <p className="mono truncate text-xl font-bold" data-testid="totals-grand-total">{inr(totals.total)}</p>
      </div>
      <button className="btn btn-accent shrink-0 px-5" onClick={onSave} disabled={saving || uploading} data-testid="save-po-btn">
        {saving || uploading ? <Loader2 size={18} className="animate-spin" /> : <Save size={18} />}
        {uploading ? "Uploading…" : label}
      </button>
    </div>
  </div>
  );
};
